export const javaBasics = [
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `Java is a popular programming language that is widely used for developing a variety of applications, including web applications, mobile apps, and desktop software. Here is a simple example of a Java program that prints "Hello, World!" to the console:`,
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q1/src/App.java',
        img: 'none',
        class: 'pointClass'
    },
    {
        img: require('../media/Java-1.webp'),
        headStyle: 'none',
        headerStyle: 'none',
        des: `To run this program, you will need to have the Java Development Kit (JDK) installed on your computer. You can then use a Java compiler, such as javac, to compile the program and a Java interpreter, such as java, to run the program.`,
        class: 'pointClass',

    },
    {
        imgClass: 'none', headStyle: 'none',
        headerStyle: 'none',
        des: `Here is a brief explanation of how this program works:`,
        class: 'pointClass'

    },
    {
        imgClass: 'none', headStyle: 'none', img: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- The public class Main declaration defines a new class called Main and specifies that it is a "public" class, which means that it is visible to other classes and can be used by other programs.\n`
    },
    {
        imgClass: 'none',
        img: 'none',
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- The main method is the entry point of a Java program. It is where the program starts executing when you run it. The main method must be defined within a class, and it must have a specific signature: public static void main(String[] args).`
    },
    {
        img: require('../media/Java-2.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- The System.out.println statement is used to print a line of text to the console. The println method is a method of the PrintStream class, which is a part of the System.out object. The println method takes a single argument, which is the string of text that you want to print. In this case, the string is "Hello, World!".`
    },
    {
        img: require('../media/Java-3.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Data types: Java has a range of data types, such as integers, floating-point numbers, characters, and strings, that you can use to store and manipulate data in your programs. It is important to choose the appropriate data type for your variables and constants to ensure that your program works correctly and efficiently`
    },
    {
        img: require('../media/Java-4.png'),
        class: 'pointClass',
        headStyle: 'none',
        headerStyle: 'none',
        des: `- Operators: Java has a variety of operators, such as arithmetic operators, relational operators, and logical operators, that you can use to perform calculations and make comparisons in your programs. You can use these operators to manipulate data, control the flow of your program, and make decisions based on the values of your variables.`
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'none',
        img: require('../media/Java-5.png')
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'none',
        img: require('../media/Java-6.png')
    },
    {
        imgClass: 'none',
        img: 'none',
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Control structures: Java has several control structures, such as if statements, for loops, and while loops, that you can use to control the flow of your program. These structures allow you to execute certain blocks of code based on certain conditions or to repeat a block of code multiple times.`
    },
    {
        img: require('../media/Java-7.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Methods: A method is a self-contained block of code that performs a specific task. You can define your own methods in Java and reuse them in your program to avoid repeating the same code multiple times. This can make your program more organized and easier to maintain.`
    },
    {
        img: require('../media/Java-8.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Objects and classes: Java is an object-oriented programming language, which means that you can use it to model real-world concepts as objects. An object is a combination of data and behavior, and a class is a template for creating objects. You can use objects and classes to represent complex data structures and to structure your program in`
    },
    {
        img: require('../media/Java-9.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Inheritance: Inheritance is a feature of object-oriented programming that allows you to create a new class that is based on an existing class. The new class, called the subclass, inherits the properties and behaviors of the existing class, called the superclass. Inheritance allows you to reuse code and to create relationships between classes in your program.`
    },
    {
        imgClass: 'none',
        img: 'none',
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Interfaces: An interface is a collection of related methods that a class can implement. An interface defines a set of behaviors that a class must implement, but it does not provide any implementation for those behaviors. This allows you to define common behaviors for different classes and to use those classes in a consistent way.`
    },
    {


        img: require('../media/Java-10.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Exceptions: An exception is an error that occurs during the execution of a program. Java has a built-in mechanism for handling exceptions, which allows you to detect and respond to errors in your program. This can help you prevent your program from crashing and can make it more robust and reliable.`
    },
    {


        img: require('../media/Java-11.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Collections: The Java Collections Framework is a set of classes and interfaces that provide efficient and convenient ways to work with collections of data, such as lists, sets, and maps. The Collections Framework includes a wide range of classes and interfaces that you can use to store, retrieve, and manipulate data in your programs.`
    },
    {


        img: require('../media/Java-12.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Threads: A thread is a separate execution path in a program. Java has a built-in mechanism for creating and managing threads, which allows you to write programs that can perform multiple tasks concurrently. This can make your programs more efficient and responsive, especially when you need to perform long-running or resource-intensive tasks.`
    },
    {


        img: require('../media/Java-13.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Networking: Java has a rich set of classes and interfaces that you can use to create programs that can communicate over a network. You can use Java to create client-server applications, web applications, and other types of networked programs.`
    },
    {
        imgClass: 'none',


        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- JavaFX: JavaFX is a set of graphics and media packages that you can use to create rich and interactive applications for the desktop, web, and mobile devices. JavaFX includes a wide range of features, such as animation, effects, and media support, that you can use to create visually appealing and engaging applications.`
    },
    {
        imgClass: 'none',


        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- JavaEE: JavaEE (Enterprise Edition) is a set of technologies and specifications for developing enterprise-level applications in Java. JavaEE includes a wide range of features, such as web services, security, and database connectivity, that you can use to create scalable and robust applications for the enterprise.`
    },
    {


        img: require('../media/Java-14.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Android development: Android is a popular mobile operating system that is based on the Linux kernel and the Java programming language. You can use Java to develop Android apps using the Android Software Development Kit (SDK). The Android SDK includes a range of tools, such as the Android Studio IDE, that you can use to create, test, and debug Android apps.`
    },
    {
        imgClass: 'none',


        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Java 11 and newer versions: Java 11 is the latest long-term support (LTS) release of the Java programming language. Java 11 includes a number of new features and improvements, such as the Java Flight Recorder, the Epsilon garbage collector, and the ZGC garbage collector. You can use Java 11 and newer versions to develop a wide range of applications, including desktop, web, and mobile apps.`
    },
    {
        imgClass: 'none',


        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Frameworks and libraries: There are many frameworks and libraries available for Java that you can use to simplify and accelerate your development process. Some popular frameworks and libraries for Java include Spring, Hibernate, and Apache Commons. These frameworks and libraries provide a range of functionality, such as dependency injection, data persistence, and utility functions, that you can use to build more complex and feature-rich applications.`
    },
    {


        img: require('../media/Java-16.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Best practices: As you learn Java and develop more complex programs, it is important to follow best practices to ensure that your code is well-structured, maintainable, and efficient. Some best practices for Java development include writing clean and readable code, using appropriate design patterns, and following naming conventions.`
    },
    {


        img: require('../media/Java-15.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Debugging and testing: Debugging and testing are important aspects of software development that help you identify and fix errors in your code and ensure that your program behaves as expected. Java provides a range of tools and techniques that you can use to debug and test your programs, such as the println statement, the assert statement, and the junit testing framework.`
    },
    {


        img: require('../media/Java-17.png'),
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Performance optimization: As your programs become more complex and resource-intensive, it is important to optimize their performance to ensure that they run efficiently and do not consume too many resources. Java provides a range of tools and techniques that you can use to optimize the performance of your programs, such as profiling, optimizing memory usage, and optimizing code execution.`
    },
    {


        img: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi0.wp.com%2Fwww.hopetutors.com%2Fwp-content%2Fuploads%2F2018%2F07%2FJava-2.png&f=1&nofb=1&ipt=b0c0d59ff92443d668735a69ced4512c63e7bf4c042bce9b56537d6546c68716&ipo=images',
        headStyle: 'none',
        class: 'pointClass',
        headerStyle: 'none',
        des: `- Java design patterns: A design pattern is a reusable solution to a common problem in software design. Java has a number of design patterns that you can use to structure your programs in a more effective and maintainable way. Some popular design patterns for Java include the Singleton pattern, the Factory pattern, and the Observer pattern.`
    },
    {
        imgClass: 'none',


        heading: 'Here some project of Java tutorial.',


        headerStyle: 'none',
        des: `Here we go: `
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q1/src/App.java',

        heading: 'Q1. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to p some statements like “Hello World!”.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q1/src/App.java',


        heading: 'Q2. ',
        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',
        heading: 'Q2. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to calculate room area using multiple classes.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q2/src/App.java',


        heading: 'Q2. ',
        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q2/src/Area.java',


        heading: 'Q2. ',
        headStyle: 'none',
        class: 'pointClass',

        des: `Area.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q3. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the use of command line arguments.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q3/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q4. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain the basic data types used in java.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q4/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q5. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain the type casting in java.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q5/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q5/src/explicitCasting.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `ExplicitCasting.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q5/src/implicitCasting.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `ImplicitCasting.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q6. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate java expressions using different operators in java like relational,
        logical, bitwise operators etc.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q6/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q6/src/RelationalOperators.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `RelationalOperators.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q6/src/logicalOperators.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `logicalOperators.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q6/src/BitwiseOperator.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `BitwiseOperator.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q7. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate if-else, nested if-else, if-else ladder.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q7/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q7/src/ifElse.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `ifElse.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q7/src/nestedIfelse.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `nestedIfelse.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q7/src/ladderIfelse.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `ladderIfelse.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q8. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate switch statements.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q8/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q8/src/switchCase.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `switchCase.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q9. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate “? :” operator.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q9/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q10. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain the working of while, for and do-while loops.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q10/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q10/src/forLoop.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `forLoop.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q10/src/whileLoop.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `whileLoop.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q10/src/doWhileLoop.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `doWhileLoop.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q11. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate different types of constructors in java like default and
        parameterized.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q11/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q11/src/Student.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Student.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q12. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain method overloading and constructor overloading.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q12/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q12/src/Add.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Add.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q12/src/Sub.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Sub.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q13. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain static methods and static members.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q13/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q14. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate multilevel inheritance and super keyword.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q14/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q14/src/Car.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Car.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q15. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate method overriding in hierarchical inheritance.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q15/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q15/src/Hierarchical.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Hierarchical.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q16. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain the working of final classes and also use final methods and final variables in your
        program.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q16/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q17. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to explain the concept of finalization.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q17/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q18. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the use of abstract methods and abstract classes.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q18/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q19. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the use of access modifiers (Private, protected, public and default)`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q19/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q19/src/Public.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Public.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q19/src/Private.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Private.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q19/src/Protected.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Protected.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q20. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WA menu driven program to add, subtract and multiply two matrices.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q20/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q20/src/AddMatrix.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `AddMatrix.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q20/src/SubMatrix.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `SubMatrix.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q20/src/SubMatrix.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `MulMatrix.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q21. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WA menu driven program for selection sort, merge sort and quick sort`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q21/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q21/src/SelectionSort.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `SelectionSort.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q21/src/QuickSort.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `QuickSort.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q21/src/MergeSort.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `MergeSort.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q22. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP in which you have to make a table to store name of students, age, course, roll no
        and this table can be ordered in following ways:
        1: Alphabetical order (A to Z or Z to A) of name
        2: smallest to greatest or greatest to smallest order of age
        3: Ascending or descending order of roll no
        4: Bachelor to master or master to bachelor order of course`
    },
    {
        imgClass: 'none',




        headStyle: 'none',
        class: 'pointClass red bold',
        headerStyle: 'none',
        des: `Not done yet!!`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q23. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the commonly used “String” and “StringBuffer” class methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q23/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q24. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate Wrapper class methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q24/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q25. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate Wrapper class methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q25/src/App.java',



        headStyle: 'none',
        class: 'pointClass',
        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q26. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate Wrapper class methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q26/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',




        headStyle: 'none',
        class: 'pointClass red bold',
        headerStyle: 'none',
        des: `Multiple inheritance not supported in class!!`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q27-Q28. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `(i). WAP to demonstrate package in java. (ii). WAP to explain static import in java with package.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q27-Q28/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q27-Q28/src/hello/Hello.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Hello.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q29-Q30. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `(i). WAP to demonstrate threading in java using Thread class.  (ii). WAP to demonstrate threading in java using Runnable interface.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q29-Q30/src/App.java',
        headStyle: 'none',
        class: 'pointClass',
        des: `App.java`
    },
    {
        imgClass: 'none',
        divStyle: ' flexRow',
        heading: 'Q33. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the use of “throw” and “throws” keyword in java.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q33/src/App.java',
        headStyle: 'none',
        class: 'pointClass',
        des: `App.java`
    },
    {
        imgClass: 'none',
        divStyle: ' flexRow',
        heading: 'Q34. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to demonstrate the use of “throw” and “throws” keyword in java.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q34/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',




        headStyle: 'none',
        class: 'pointClass red bold',
        headerStyle: 'none',
        des: `Note: Applet is not supported in latest version of java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q35. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `WAP to make graphic calculator.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q35/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q36. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Write two different programs to copy a file in another file by character by character
        and byte by byte methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q36/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q37. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Write a Java application to print Pascal’s triangle.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q37/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q38. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Write a program to compute the following series:\n
        [1 – x + x^2/2! – x^3/3! + x 4/4! + ..... + (–/+ 1)nx^n/n!]
        Where n and x is to be accepted by the user.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q38/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q39. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Define a class BankAccount with appropriate member variables and methods to
        deposit and withdraw amount. Refine BankAccount to SavingBankAccount and
        CurrentBankAccount using inheritance. Use them in main class to demonstrate dynamic
        method dispatch.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q39/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q40. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Create an abstract class Shape and derived classes Rectangle and Circle from Shape
        class. Implement abstract method of shape class in Rectangle and Circle class. Shape class
        contains: origin (x, y) as data member, display() and area() as abstract methods. Circle
        class contains: radius as data member. Rectangle class contains: length and width. (Use
        Inheritance, overloading and overriding concept)`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q40/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q41. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Create a package named as MyPackage with a class named as Calculate. The class
        should contain three methods with the following specifications:
        • Volume(): Accepts three double type arguments i.e. width, height, depth; calculate
        volume and return double type value.
        • Add(): Accepts two integer type values, adds them and returns the value.
        • Divide(): Accepts two integer type values, adds them and returns results.
        Import this package into a file named as PackageDemo and call the above three
        methods.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q41/src/PackageDemo/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q41/src/MyPackage/Calculate.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `Calculate.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q42. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Write a program that will count number of characters, words and lines in a file. The
        name should be passes as command line argument.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q42/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
    {
        imgClass: 'none',

        divStyle: ' flexRow',

        heading: 'Q43. ',
        headStyle: 'headingSmall',
        class: 'headingSmall',
        headerStyle: 'none',
        des: `Write a multi-threaded Java program to print all numbers below 100,000 that are
        both prime and Fibonacci number (some examples are 2, 3, 5, 13, etc.). Design a thread
        that generates prime numbers below 100,000 and writes them into a pipe. Design another
        thread that generates Fibonacci numbers and writes them to another pipe. The main
        thread should read both the pipes to identify numbers common to both.`
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/basic-java/main/Q43/src/App.java',



        headStyle: 'none',
        class: 'pointClass',

        des: `App.java`
    },
]
export const softwareEngineering = [
    {
        imgClass: 'none',
        headerStyle: 'none',
        headStyle: 'headingSmall',
        class: 'pointClass',
        heading: 'What is Software Engineering?',
        des: 'Software engineering is the process of designing, developing, and maintaining software systems. It involves applying engineering principles and practices to the development of software, with the goal of creating reliable, efficient, and maintainable systems.'
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: 'Software engineering differs from traditional software development in that it emphasizes the use of structured processes, well-defined methodologies, and careful planning to ensure the quality and reliability of the final product.',
        img: require('../media/Software-Engineering-1.WebP')
    },
    {
        imgClass: 'none',
        headerStyle: 'none',
        headStyle: 'headingSmall',
        class: 'pointClass',
        heading: 'Why is Software Engineering Important?',
        des: 'Software engineering is important because it helps to ensure that software systems are built to meet the needs of their users and are able to function effectively and efficiently.'
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: 'Properly designed and developed software systems can improve productivity, reduce errors and costs, and increase customer satisfaction. On the other hand, poorly designed and developed software can lead to a range of problems, including security vulnerabilities, poor performance, and high maintenance costs.',
        img: require('../media/Software-Engineering-2.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        divStyle: ' flexRow',
        des: ' - Requirements gathering and analysis: This involves identifying and documenting the needs and requirements of the users of the software system.',
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        divStyle: ' flexRow',
        des: ' - Design: This involves creating a detailed plan for the structure and functionality of the software system.',
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        divStyle: ' flexRow',
        des: ' - Implementation: This involves writing the code for the software system based on the design plan.',
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        divStyle: ' flexRow',
        des: ' - Testing: This involves verifying that the software system functions as intended and meets the requirements defined in the design phase.',
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        divStyle: ' flexRow',
        des: ' - Maintenance: This involves making updates and fixes to the software system over time to ensure its continued effectiveness and efficiency.',
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: 'Software engineering is a complex and constantly evolving field, and there are many different approaches and methodologies used in the development of software systems. However, by understanding these key concepts and applying sound engineering principles, software engineers can create high-quality software systems that meet the needs of their users and are able to stand the test of time.',
        img: require('../media/Software-Engineering-3.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'headingSmall',
        heading: 'Here are a few additional examples that illustrate some of the key concepts in software engineering:',
        class: 'pointClass',
        des: '- Requirements gathering and analysis: In order to build a software system that meets the needs of its users, it is important to first understand what those needs are. This might involve conducting user research, gathering feedback from stakeholders, and creating user stories or user personas to define the target audience for the software.',
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        des: `For example, let's say we are building a task management app for small business owners. Some of the requirements we might gather and analyze might include:`,
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - The ability to create and assign tasks to team members`,
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - The ability to set deadlines and priorities for tasks`,
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - The ability to track the progress of tasks`,
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - The ability to generate reports on task completion`,
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - Design: Once we have gathered and analyzed the requirements for our task management app, we can begin to design the structure and functionality of the app. This might involve creating wireframes or prototypes to visualize the layout and flow of the app, and determining how the various features will work together.`,
        img: require('../media/Software-Engineering-4.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: `For example, we might design the app to have a main dashboard that shows a list of tasks, a calendar view of deadlines, and a progress bar for each task. We might also design the app to have a task detail view that shows more information about a specific task, including any notes or attachments associated with the task.`,
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - Implementation: Once we have a detailed design plan for our task management app, we can begin to write the code that will bring the app to life. This might involve choosing a programming language and frameworks, setting up a development environment, and writing the code that implements the various features and functionality of the app.`,
        img: require('../media/Software-Engineering-5.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: `For example, we might use Java or Kotlin for the backend of the app, and Android Studio for the frontend. We might also use a database to store information about tasks and users, and use APIs to enable communication between the various components of the app.`,
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - Testing: Once we have implemented the code for our task management app, it is important to test it to ensure that it functions as intended and meets the requirements defined in the design phase. This might involve creating test cases and running the app through a series of tests to verify that it performs as expected. Testing might include unit testing to verify the behavior of individual components of the app, as well as integration testing to verify that the app functions correctly when all the components are working together.`,
        img: require('../media/Software-Engineering-6.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: `For example, we might create a test case to verify that the app correctly displays a list of tasks when the user logs in, and another test case to verify that the app allows the user to create and assign new tasks. We might also create test cases to verify that the app handles error cases, such as when the user tries to create a task with a deadline in the past, or when the user tries to access a task that does not belong to them.`,
    },
    {
        headerStyle: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: ` - Maintenance: Once our task management app is released to users, it is important to continue to maintain and update the app over time to ensure its continued effectiveness and efficiency. This might involve fixing bugs, adding new features, and making performance improvements based on user feedback.`,
        img: require('../media/Software-Engineering-7.png')
    },
    {
        headerStyle: 'none',
        imgClass: 'none',
        headStyle: 'none',
        class: 'pointClass',
        des: `For example, we might release an update to the app that adds the ability to set recurring tasks, or that improves the performance of the app on older devices. We might also create a system for tracking and addressing user issues and feature requests, and regularly release updates to the app to address these issues and add new functionality.`,
    },
]
export const uiux = [
    {
        img: require('../media/UiUx1.png'),
        headStyle: 'none',
        des: 'UI/UX design is an important aspect of creating software and web applications that are not only functional but also visually appealing and user-friendly. The term UI stands for "User Interface" and refers to the graphical elements of an application, such as buttons, icons, and other visual elements that a user interacts with. UX, on the other hand, stands for "User Experience" and refers to the overall experience a user has when using a product or service, including factors such as ease of use, navigation, and overall satisfaction.',
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: 'UI and UX design are often used interchangeably, but they are distinct disciplines that work together to create a cohesive and enjoyable user experience. A good UI design should be aesthetically pleasing, with visually appealing graphics and color schemes. It should also be intuitive, so that users can easily understand how to interact with the application.',
        headerStyle: 'none'
    },
    {
        img: require('../media/UiUx2.png'),
        headStyle: 'none',
        des: `UX design, on the other hand, focuses on creating an intuitive and user-friendly experience. A good UX design should take into account the user's goals, motivations, and needs. It should be easy to navigate, with clear and concise instructions. UX designers will often conduct user research, testing, and analysis to understand how users interact with their products and make changes to improve the overall experience.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `For example, let's consider a shopping app. The UI designer might focus on the design of the product images and the layout of the product list, while the UX designer might focus on the process of navigating through the product list and making a purchase.`,
        headerStyle: 'none'
    },
    {
        img: require('../media/UiUx3.png'),
        headStyle: 'none',
        des: `When designing software applications, it is important to consider both UI and UX, as both play a crucial role in the overall success of the application. A well-designed UI can make the application visually appealing and easy to use, while a well-designed UX can ensure that the application is efficient, accessible, and provides a positive experience for the user.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'headingSmall',
        heading: 'UI/UX design',
        des: ` is a critical component of modern web and mobile application development. It refers to the process of designing the user interface and user experience of a digital product, such as a website or mobile app. The goal of UI/UX design is to create a product that is both functional and aesthetically pleasing to the end user.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'headingSmall inline',
        class: 'inline',
        heading: 'UI (user interface)',
        des: `user interface design focuses on the visual elements of a product, such as the layout, color scheme, typography, and button placement. The goal of UI design is to make the product easy to use and navigate, and to provide a clear visual hierarchy to the information presented on the screen. UI design refers to the visual aspects of a product, such as its layout, typography, color palette, and other design elements. The aim of UI design is to make the product aesthetically pleasing and easy to navigate. Good UI design should also be consistent throughout the product, ensuring that users can easily recognize and understand the different elements of the product.`,
        headerStyle: 'none'
    },
    {
        img: require('../media/UiUx4.png'),
        headStyle: 'headingSmall inline',
        class: 'inline',
        heading: ' UX (user experience)',
        des: `user experience design, on the other hand, focuses on the overall experience a user has when using a product. This includes the ease of use, speed of performance, and the overall satisfaction a user feels when using the product. UX design, on the other hand, is more concerned with the overall user experience. It takes into consideration how users interact with the product, what their needs are, and what they expect from the product. UX designers aim to create products that are intuitive, efficient, and satisfying to use. They analyze the user behavior, conduct user research, and use various techniques and tools to design products that meet the users' needs.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `A well-designed UI/UX can significantly improve the user's experience of a product and can lead to increased customer satisfaction, engagement, and loyalty. Conversely, poor UI/UX design can lead to frustration, confusion, and a decrease in customer satisfaction. Both UI and UX design play a crucial role in the success of a product. A product with excellent UI design but poor UX design will fail to retain users, while a product with excellent UX design but poor UI design will fail to attract users. As a result, it's essential to have a balanced approach to UI and UX design to create a product that not only looks good but also provides a great user experience.`,
        headerStyle: 'none'
    },
    {
        img: require('../media/UiUx5.png'),
        headStyle: 'headingSmall inline',
        class: 'inline',
        heading: 'Example:',
        des: `Let's take the example of a shopping website. A good UI design for this website would include an attractive layout, clear and easy-to-read typography, a well-structured navigation, and a visually appealing color palette. A good UX design for this website would ensure that users can quickly find the products they're looking for, complete their purchase efficiently, and have a satisfying experience while doing so.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `In summary, UI/UX design is a critical component of digital product development, and it is important to take the time to carefully design the user experience and user interface to ensure a positive user experience.`,
        headerStyle: 'none'
    },
]
export const htmlCss = [
    {
        img: require('../media/Html-Css-1.png'),
        headStyle: 'none',
        des: `HTML (HyperText Markup Language) and CSS (Cascading Style Sheets) are two of the core technologies for building websites and web applications. HTML is used to structure and organize content on the web, while CSS is used to control the appearance and layout of web pages. Here is an example of a blog post that combines HTML and CSS to create a simple web page:`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `HTML and CSS: A Beginner's Guide`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'headingSmall',
        heading: `HTML and CSS are essential tools for building websites and web applications. In this post, we'll take a look at the basics of HTML and CSS and how they work together to create the structure and style of a web page.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `HTML and CSS are essential tools for building websites and web applications. In this post, we'll take a look at the basics of HTML and CSS and how they work together to create the structure and style of a web page.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        heading: `HTML`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `HTML is a markup language that is used to structure and organize content on the web. It is made up of a series of elements, which are represented by tags. For example, the <p> tag is used to define a paragraph of text, and the <h1> tag is used to define a heading.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `Here's an example of some simple HTML code:`,
        code: `<h1>Welcome to My Website</h1>\n<p>Hello, my name is Jane and this is my website. I am a web developer and I love to build beautiful and functional websites.</p>`
    },
    {
        imgClass: 'none',
        heading: `CSS`,
        des: `CSS is a style sheet language that is used to control the appearance and layout of web pages. It allows you to apply styles, such as fonts, colors, and margins, to your HTML elements.`,
        headerStyle: 'none'
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `Here's an example of some simple CSS code:`,
        code: `h1 {\nfont-size: 36px;\ncolor: blue;\n}\n\np {\nfont-size: 18px;\ncolor: black;\nmargin: 20px;\n}\n`
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `Combining HTML and CSS`,
        headerStyle: 'none',
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `To use CSS to style your HTML elements, you need to link your CSS file to your HTML file. This can be done using the <link> tag in the head of your HTML file:`,
        code: `<head>\n   <link rel="stylesheet" href="style.css">\n</head>`
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `Then, you can use class and id attributes in your HTML tags to apply your styles. For example:`,
        code: `<h1 class="main-heading">Welcome to My Website</h1>\n<p id="intro-text">Hello, my name is Jane and this is my website. I am a web developer and I love to build beautiful and functional websites.</p>`
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        class: 'none',
        code: `.main-heading {\nfont-size: 36px;\ncolor: blue;\n}\n\n#intro-text {\nfont-size: 18px;\ncolor: black;\nmargin: 20px;\n}`
    },
    {
        imgClass: 'none',
        headStyle: 'none',
        des: `With HTML and CSS, you can create the structure and style of a web page and build beautiful and functional websites.`,
        headerStyle: 'none',
    },
    {
        class: 'none',
        headStyle: 'none',
        img: 'https://4.bp.blogspot.com/-oHMa7P0GxnU/VUe5vTdMBxI/AAAAAAAALTw/LTEB77VmLkA/s1600/html5_css3.png',
        headerStyle: 'none',
    },
    {
        imgClass: 'none',
        headStyle: 'headingSmall',
        heading: 'Here some project of HTML CSs which is given by as a College projects.',
        des: `Now we are going to show projects`,
        headerStyle: 'none',
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q1/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q1. ',
        class: 'headingSmall',
        des: `Now we are going to show projects`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q2/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q2. ',
        class: 'headingSmall',
        des: `Design a web page to display the information of MCA department of jamia hamdard by using basic page tags. Display the information in the form of paragraph/sentences. Also use effects to highlight the information like bold, italic,or underlined`,
    },
    {
        imgClass: 'none',
        headerStyle: 'none',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q3. ',
        class: 'headingSmall',
        des: `Create a hyperlink to show the information and syllabus of management and engineering MCA.
        When click on the links each page should display the objective of respective course, fees, duration and
        year wise and semester wise.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q3/index.html',
        headStyle: 'none',
        class: 'pointClass',
        des: `index.html`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q3/home.html',
        headStyle: 'none',
        class: 'pointClass',
        des: `home.html`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q4/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q4. ',
        class: 'headingSmall',
        des: `Design a page to display the information in table format. Display the list of MCA colleges along with
        the details University Name, MCA stream, Address, Contact no. Address column will consist of sub
        columns as area, colony, city and pin code.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q5/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q5. ',
        class: 'headingSmall',
        des: `Design a HTML form for reserving a room in the Hotel.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment1/q6/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q6. ',
        class: 'headingSmall',
        des: `Design a HTML form to see the result for the candidate when the results are published on the web.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment2/q1/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q7. ',
        class: 'headingSmall',
        des: `Design a HTML page of your Biodata form`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment2/q2/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q8. ',
        class: 'headingSmall',
        des: `Create a table to show your class time table.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment2/q3/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q9. ',
        class: 'headingSmall',
        des: `Develop static pages (using only HTML) of an online book store. The website
        should consist the following pages, home page, registration and user login, user profile page, books catalog, shopping cart, payment by credit card, order
        confirmation.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment2/q4/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q10. ',
        class: 'headingSmall',
        des: `Create a webpage with HTML describing your department use paragraph
        and list tags.
        Apply various colors to suitably distinguish key words, also apply font styling
        like italics, underline and two other fonts to words you find appropriate. Insert
        an image and create a link such that clicking on image takes user to other page.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment3/Q1/index.html',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q11. ',
        class: 'headingSmall',
        des: `Write the html code to illustrate the usage of the following
        • Ordered list
        • Unordered list
        • Definition list`,
    },
    {
        imgClass: 'none',
        headerStyle: 'none',
        headStyle: 'headingSmall',
        divStyle: ' flexRow',
        heading: 'Q12. ',
        class: 'headingSmall',
        des: `Write a code to demonstrate the usage of inline css, internal css, external css.`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment3/Q2/index.html',
        headStyle: 'none',
        class: 'pointClass',
        des: `index.html`,
    },
    {
        imgClass: 'none',
        url: 'https://raw.githubusercontent.com/Zer-0ne/htmlProject/main/assignment3/Q2/style.css',
        headStyle: 'none',
        class: 'pointClass',
        des: `style.css`,
    },
]